module.exports = __webpack_public_path__ + "58dda92b.png";